import { getHojeBR } from './dataBR';

const CSV_URL =
  'https://docs.google.com/spreadsheets/d/1_tZhP4PAscEqcGQf61jlFeOrvTGtb9Ab/export?format=csv&gid=1302878991';

// Fallbacks por categoria caso o fetch falhe
const FALLBACKS = {
  amor:          'O amor que você busca começa no silêncio de quem você é.',
  trabalho:      'Seu propósito não está no que você faz, mas em como você faz.',
  familia:       'As raízes sustentam a árvore mesmo quando os ventos chegam fortes.',
  autocuidado:   'Cuidar de si não é egoísmo — é a base de tudo que você oferece ao mundo.',
  financas:      'A abundância flui para quem reconhece o valor do que já tem.',
  espiritualidade: 'A intuição fala baixinho. Aprenda a ouvir nos momentos de silêncio.',
};

// Parser simples de CSV que respeita vírgulas dentro de aspas
function parseCSV(text) {
  const lines = text.split('\n').filter(l => l.trim());
  // remove header
  return lines.slice(1).map(line => {
    // Encontra a primeira vírgula fora de aspas
    let inQuote = false;
    let splitIdx = -1;
    for (let i = 0; i < line.length; i++) {
      if (line[i] === '"') inQuote = !inQuote;
      if (line[i] === ',' && !inQuote) { splitIdx = i; break; }
    }
    if (splitIdx === -1) return null;
    const cat = line.substring(0, splitIdx).trim().replace(/^"|"$/g, '');
    const frase = line.substring(splitIdx + 1).trim().replace(/^"|"$/g, '');
    return cat && frase ? { categoria: cat, frase } : null;
  }).filter(Boolean);
}

export async function buscarOraculo(categoria) {
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 6000);
    const res = await fetch(CSV_URL, { cache: 'no-store', signal: controller.signal });
    clearTimeout(timeoutId);
    if (!res.ok) throw new Error('fetch failed');
    const csv = await res.text();
    const todos = parseCSV(csv);
    const filtrados = todos.filter(o => o.categoria.toLowerCase() === categoria.toLowerCase());
    if (!filtrados.length) throw new Error('sem resultados');
    const escolhido = filtrados[Math.floor(Math.random() * filtrados.length)];
    return { frase: escolhido.frase, erro: null };
  } catch {
    return { frase: FALLBACKS[categoria] || FALLBACKS.espiritualidade, erro: 'fallback' };
  }
}

export function deveExibirOraculo() {
  const visto = localStorage.getItem('oraculo_visto');
  return visto !== getHojeBR();
}

export function marcarOraculoVisto() {
  localStorage.setItem('oraculo_visto', getHojeBR());
}
